export function getFilename(path: string | undefined) {
  if (!path) return ""
  const trimmed = path.replace(/[\/\\]+$/, "")
  const parts = trimmed.split(/[\/\\]/)
  return parts[parts.length - 1] ?? ""
}

export function getDirectory(path: string | undefined) {
  if (!path) return ""
  const trimmed = path.replace(/[\/\\]+$/, "")
  const parts = trimmed.split(/[\/\\]/)
  return parts.slice(0, parts.length - 1).join("/") + "/"
}

export function getFilenameTruncated(path: string | undefined, maxLength: number = 20) {
  const filename = getFilename(path)
  if (filename.length <= maxLength) return filename
  const lastDot = filename.lastIndexOf(".")
  const ext = lastDot <= 0 ? "" : filename.slice(lastDot)
  const available = maxLength - ext.length - 1 // -1 for ellipsis
  if (available <= 0) return filename.slice(0, maxLength - 1) + "…"
  return filename.slice(0, available) + "…" + ext
}

/** Display-only: replace machine home prefix with `~` (Linux/macOS/Windows). */
export function tildePath(path: string | undefined, home?: string) {
  if (!path) return ""
  if (!home) return path

  const normalizedHome = home.replace(/[/\\]+$/, "")
  if (!normalizedHome) return path

  const normalizedPath = path.replace(/[/\\]+$/, "") || path
  if (normalizedPath === normalizedHome) return "~"

  if (path.startsWith(normalizedHome + "/")) {
    return "~" + path.slice(normalizedHome.length)
  }
  if (path.startsWith(normalizedHome + "\\")) {
    return "~" + path.slice(normalizedHome.length).replace(/\\/g, "/")
  }
  return path
}

export function shortenPath(path: string | undefined, home?: string, maxLength = 35) {
  if (!path) return ""
  const resolved = tildePath(path, home)
  if (resolved.length <= maxLength) return resolved

  const parts = resolved.split("/")
  if (parts.length <= 3) return resolved

  const first = parts[0]
  const second = parts[1]
  const last = parts.at(-1)

  const prefix = [first, second].filter(Boolean).join("/")
  const suffix = last

  const middle = "..."
  const combined = `${prefix}/${middle}/${suffix}`
  if (combined.length <= maxLength) return combined

  return `.../${suffix}`
}


